import { render, staticRenderFns } from "./CustomerOrdersPopup.vue?vue&type=template&id=7e98f673&"
import script from "./CustomerOrdersPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports